import React, { useState } from 'react';
import Contact, { CreateContactOptions, LegacyContact } from 'src/interfaces/api/Contact';
import { Button } from '@material-ui/core';
import { createUseStyles } from 'src/theming';
import AddContactDialog from './components/AddContactDialog';
import ContactsList from './components/ContactsList';
import { Alert } from '@material-ui/lab';

interface Props {
  contacts: LegacyContact[];
  contactsV2: Contact[];
  onAddContact: (siteId: string, contact: Contact) => void;
  onMigrateContact: (contactOptions: CreateContactOptions) => void;
  onRevokeCustomerAccess: (contactId: string) => void;
  siteId?: string;
  loading: boolean;
}

const useStyles = createUseStyles({
  add: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 15,
  },
  alert: {
    marginBottom: 15,
  },
});

const ContactsSection: React.FC<Props> = ({
  onRevokeCustomerAccess,
  onMigrateContact,
  onAddContact,
  siteId,
  contactsV2,
  contacts,
  loading,
  ...props
}) => {
  const classes = useStyles();
  const [addContactDialogOpen, setAddContactDialogOpen] = useState(false);

  const handleAddExistingContact = async (contact: Contact) => {
    try {
      await onAddContact(siteId!, contact);
      setAddContactDialogOpen(false);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return (
    <div {...props}>
      {!siteId && (
        <Alert severity='warning' className={classes.alert}>
          Vous devez migrer le client pour pouvoir créer un accès à l'espace client
        </Alert>
      )}

      <ContactsList
        onRevokeCustomerAccess={onRevokeCustomerAccess}
        onMigrateContact={onMigrateContact}
        loading={loading}
        siteId={siteId}
        contacts={contacts}
        contactsV2={contactsV2}
      />

      {siteId && (
        <div className={classes.add}>
          <Button variant='contained' color='primary' size='small' onClick={() => setAddContactDialogOpen(true)}>
            + Ajouter un contact existant
          </Button>
        </div>
      )}

      <AddContactDialog
        open={addContactDialogOpen}
        onClose={() => setAddContactDialogOpen(false)}
        onValidate={(contact) => handleAddExistingContact(contact)}
      />
    </div>
  );
};
export default ContactsSection;
